const CopyButton = ({
  data,
  title,
  size = 14,
}: {
  data: unknown;
  title: string;
  size?: number;
}) => (
  <button
    onClick={() => {
      navigator.clipboard.writeText(JSON.stringify(data, null, 2));
    }}
    style={{
      background: "none",
      border: "none",
      cursor: "pointer",
      padding: "4px",
      display: "flex",
      alignItems: "center",
      color: "#6c757d",
    }}
    title={title}
  >
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
    </svg>
  </button>
);

export default CopyButton;
